import type {IIsomorphicHttpClient} from "@wix/devzai-utils-common";
import {asyncCachedValueCreate, asyncWithRetries} from "@wix/devzai-utils-common";

export async function doppeClientHttpClientCreate (
    options: {
        baseUrl?: string;
    } = {}
) {
    const {
        baseUrl
    } = options;

    const {
        HttpClient
    } = await asyncWithRetries(() => import('@wix/http-client'), {retries: 3, interval: 1000});

    return new HttpClient({
        artifactId: 'com.wixpress.doppe',
        baseURL: baseUrl
    });
}

export function doppeClientHttpClientCreateIsomorphic (
    options: {
        baseUrl?: string;
    } = {}
) : IIsomorphicHttpClient {

    const lazyHttpClient = asyncCachedValueCreate(() => doppeClientHttpClientCreate(options))

    return {
        request: async function<T>(requestConfig: IIsomorphicHttpClient.RequestConfig): Promise<T> {
            const response = await (await lazyHttpClient.getValue()).request(requestConfig);

            return response.data;
        }
    }
}

export type DoppeHttpClient = Awaited<ReturnType<typeof doppeClientHttpClientCreate>>